import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import { CredentialResponse } from '@/app/api/account/get-totp/route';
import ApiContext from '@/context/ApiContext/ApiContext';
import HealthStatusContext from '@/context/HealthStatusContext/HealthStatusContext';

interface IUseGetPractitioners {
  totp?: Array<CredentialResponse>;
  isPending: boolean;
}

const useGetTotp = (enabled = true): IUseGetPractitioners => {
  const { areSystemsAvailable } = useContext(HealthStatusContext);
  const { client } = useContext(ApiContext);

  const { data: totp, isPending } = useQuery<
    Array<CredentialResponse>,
    AxiosError
  >({
    queryKey: ['api', 'account', 'get-totp'],
    queryFn: async ({ queryKey }) => {
      return (
        await client.current!.get<Array<CredentialResponse>>(queryKey.join('/'))
      ).data;
    },
    enabled: areSystemsAvailable && enabled && !!client.current,
  });

  return {
    totp,
    isPending,
  };
};

export default useGetTotp;
